import React from "react";
import { Typography } from "@mui/material";

const Settings = () => {
  return (
    <div style={{ padding: "3rem" }}>
      <Typography variant="h4" className="titles">Settings</Typography>
    </div>
  );
};

export default Settings;
